import Lottie from "lottie-react";
import filesLoadingAnimation from "./Loading-files.json";

const LoadingAnimation = () => {
  return <Lottie animationData={filesLoadingAnimation} loop={true} autoPlay={true}/>;
};

export default LoadingAnimation;